import { Component, OnInit } from '@angular/core';
import {AppService} from '../app.service';
import {ActivatedRoute} from '@angular/router';
import {LocalStorageService, SessionStorageService} from 'angular-web-storage';
import {environment} from '../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-searchapp',
  templateUrl: './searchapp.component.html',
  styleUrls: ['./searchapp.component.scss']
})
export class SearchappComponent implements OnInit {

  accessPrivileges: string;
  searchAppList: any;
  searchSourceList: any;

  constructor(
    private _appService: AppService,
    private _route: ActivatedRoute,
    private sessionStorage: SessionStorageService,
    private localStorage: LocalStorageService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {


    if (this.sessionStorage.get('accessPrivileges')) {
      this.accessPrivileges = this.sessionStorage.get('accessPrivileges');
    } else {
      this.accessPrivileges = environment.appPrivilege;
    }

  }

  searchApps(key: string) {

    this.spinner.show();

    this._appService.searchApps(key).subscribe(res => {
      this.searchAppList  = res;
      this.spinner.hide();
    });

    this._appService.searchSources(key).subscribe(res => {
      console.log(res);
      this.searchSourceList  = res;
      this.spinner.hide();
    });
  }


}
